





















































































import Vue from 'vue'
import Component from "vue-class-component";
import {Action} from "vuex-class";
import {cloneDeep, isEqual} from "lodash";
import {ProxySettingItem} from "@/store/settings/proxy_settings/types";
import {InputWings, NumberWings} from "wings-ui-components";
import { notifyError, notifyDelete, notifyConfirm } from '@/utils/notify-helper';
import {Ref} from "vue-property-decorator";
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";

Component.registerHooks([
  'beforeRouteLeave',
])

@Component({components: {NumberWings, InputWings}})
export default class ProxySetting extends Vue {
  @Ref('validator') validator:any;

  @Action("getProxySettingItem") actionGetItem: any;
  @Action("saveProxySettings") actionSave: any;
  @Action("deleteProxySetting") actionDelete: any;
  @Action("actionLog") actionLog: any;


  defaultItem(): ProxySettingItem {
    return {
      name: "",
      host: null,
      port: null
    };
  }

  private item = this.defaultItem();
  private itemSaved = this.defaultItem();
  private logObject: ActionLog = {}

  async created() {
    if (this.$route.params.id) {
      try {
        const data = await this.actionGetItem(this.$route.params.id);
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: 'success',
          object_type: "Proxy-servers",
          addititional_info: getTranslatedParams({id: data.id})
        }
        await this.actionLog(this.logObject)
        this.item = Object.assign({},this.item, data);
        this.itemSaved = cloneDeep(Object.assign({},this.item, data));
      }catch (err) {
        await this.actionLog({...this.logObject, action_status: 'failed'})
      }
    }
  }

  back():void{
    this.$router.push('/settings/proxy/');
  }

  onSaveItem():Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let valid:boolean = await this.validator.validate();
      if (valid) {
        try {
          this.logObject = {
            action_page: this.$route.meta.msgKey,
            action: this.$route.params.id ? "Editing" : "Creation",
            action_status: "success",
            object_type: "Proxy-servers",
            object_name: this.item.name,
            addititional_info: getTranslatedParams(this.item)
          }
          await this.actionSave(this.item);
          await this.actionLog(this.logObject);
          this.itemSaved = this.item;
          resolve();
          this.back();
        } catch (error) {
          await this.actionLog({...this.logObject, action_status: "failed"});
          reject();
          notifyError(error);
        }
      } else {
        setTimeout(() => {
          notifyError(null, this.validator.errors)
        }, 100);
      }
    })
  }

  async onDeleteItem():Promise<void> {
    let isConfirm:boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "Proxy-servers",
          object_name: this.item.name,
          addititional_info: getTranslatedParams({id: this.$route.params.id})
        }
        await this.actionDelete(this.item);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    }
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    let isChange = !isEqual(this.item,this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }
}
